import * as React from 'react';

import {Button} from 'shells/button/button';

import {FileList} from './file-list';
import {uploadFiles} from './upload-files';

type Props = {
    model: any;
    hasUploadButton: boolean;
};

export class FileAttachments extends React.Component<Props> {
    static defaultProps = {
        hasUploadButton: true,
    };

    render() {
        return (
            <div>
                {this.props.hasUploadButton ? (
                    <Button variant='text-primary' size='big' onClick={this.handleUploadFiles}>
                        + Attach files
                    </Button>
                ) : undefined}
                <FileList isEmailAttachment={true} files={this.props.model.getFiles()} />
            </div>
        );
    }

    handleUploadFiles = () => {
        uploadFiles(this.props.model);
    };
}
